export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.upload.CreateSnowflakeTableForUpload.AmbiguousColumnReference';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.upload.CreateSnowflakeTableForUpload.CannotCastValueOfType';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.upload.CreateSnowflakeTableForUpload.ClientConnectionError';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_DATA_LOADING_FAILED =
    'europa.upload.CreateSnowflakeTableForUpload.DataLoadingFailed';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.upload.CreateSnowflakeTableForUpload.DatabaseNotExistsOrNotAuthorized';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_FILE_IS_EMPTY =
    'europa.upload.CreateSnowflakeTableForUpload.FileIsEmpty';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_FILE_PARSING_FAILURE =
    'europa.upload.CreateSnowflakeTableForUpload.FileParsingFailure';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.upload.CreateSnowflakeTableForUpload.InsufficientPrivileges';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.upload.CreateSnowflakeTableForUpload.InsufficientTaskPrivileges';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.upload.CreateSnowflakeTableForUpload.InvalidAccessToken';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.upload.CreateSnowflakeTableForUpload.InvalidAccountName';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_INVALID_IDENTIFIER =
    'europa.upload.CreateSnowflakeTableForUpload.InvalidIdentifier';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.upload.CreateSnowflakeTableForUpload.InvalidParameterTypeForFunction';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.upload.CreateSnowflakeTableForUpload.MaxFileSizeExceeded';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_MISSING_COLUMN =
    'europa.upload.CreateSnowflakeTableForUpload.MissingColumn';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.upload.CreateSnowflakeTableForUpload.NoActiveWarehouseSelected';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.upload.CreateSnowflakeTableForUpload.NotAuthenticatedToSnowflake';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.upload.CreateSnowflakeTableForUpload.NotExistsOrNotAuthorized';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.upload.CreateSnowflakeTableForUpload.NotExistsOrOperationCannotBePerformed';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.upload.CreateSnowflakeTableForUpload.ObjectAlreadyExists';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.upload.CreateSnowflakeTableForUpload.SchemaNotExistsOrNotAuthorized';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.upload.CreateSnowflakeTableForUpload.SnowflakeInternalServerError';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.upload.CreateSnowflakeTableForUpload.SnowflakeNotConfigured';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.upload.CreateSnowflakeTableForUpload.SnowflakeObjectNotFoundOrNotAccessible';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.upload.CreateSnowflakeTableForUpload.SnowflakeQueryCanceled';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_SNOWFLAKE_TABLE_ALREADY_EXISTS =
    'europa.upload.CreateSnowflakeTableForUpload.SnowflakeTableAlreadyExists';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_SUCCESS_SNOWFLAKE_TABLE_FOR_UPLOAD_CREATED =
    'europa.upload.CreateSnowflakeTableForUpload.SnowflakeTableForUploadCreated';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_TARGET_VIEW_OR_TABLE_NOT_ALLOWED_TO_OVERWRITE =
    'europa.upload.CreateSnowflakeTableForUpload.TargetViewOrTableNotAllowedToOverwrite';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_TIMEOUT =
    'europa.upload.CreateSnowflakeTableForUpload.Timeout';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.upload.CreateSnowflakeTableForUpload.UncategorizedSqlError';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_UNEXPECTED_FAILURE =
    'europa.upload.CreateSnowflakeTableForUpload.UnexpectedFailure';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_UNKNOWN_FUNCTION =
    'europa.upload.CreateSnowflakeTableForUpload.UnknownFunction';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.upload.CreateSnowflakeTableForUpload.UnknownFunctions';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_UPLOAD_NOT_FOUND =
    'europa.upload.CreateSnowflakeTableForUpload.UploadNotFound';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.upload.CreateSnowflakeTableForUpload.UserDiffersFromToken';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.upload.CreateSnowflakeTableForUpload.ValueNotRecognized';
export const CREATE_SNOWFLAKE_TABLE_FOR_UPLOAD_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.upload.CreateSnowflakeTableForUpload.WarehouseSuspended';
export const INITIATE_DATA_UPLOAD_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.upload.InitiateDataUpload.AmbiguousColumnReference';
export const INITIATE_DATA_UPLOAD_FAILURE_ASSET_MODIFICATION_NOT_PERMITTED =
    'europa.upload.InitiateDataUpload.AssetModificationNotPermitted';
export const INITIATE_DATA_UPLOAD_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.upload.InitiateDataUpload.CannotCastValueOfType';
export const INITIATE_DATA_UPLOAD_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.upload.InitiateDataUpload.ClientConnectionError';
export const INITIATE_DATA_UPLOAD_FAILURE_DATA_LOADING_FAILED =
    'europa.upload.InitiateDataUpload.DataLoadingFailed';
export const INITIATE_DATA_UPLOAD_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.upload.InitiateDataUpload.DatabaseNotExistsOrNotAuthorized';
export const INITIATE_DATA_UPLOAD_FAILURE_ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.upload.InitiateDataUpload.EntityNotFoundOrNotAccessible';
export const INITIATE_DATA_UPLOAD_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.upload.InitiateDataUpload.InsufficientPrivileges';
export const INITIATE_DATA_UPLOAD_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.upload.InitiateDataUpload.InsufficientTaskPrivileges';
export const INITIATE_DATA_UPLOAD_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.upload.InitiateDataUpload.InvalidAccessToken';
export const INITIATE_DATA_UPLOAD_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.upload.InitiateDataUpload.InvalidAccountName';
export const INITIATE_DATA_UPLOAD_FAILURE_INVALID_IDENTIFIER =
    'europa.upload.InitiateDataUpload.InvalidIdentifier';
export const INITIATE_DATA_UPLOAD_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.upload.InitiateDataUpload.InvalidParameterTypeForFunction';
export const INITIATE_DATA_UPLOAD_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.upload.InitiateDataUpload.MaxFileSizeExceeded';
export const INITIATE_DATA_UPLOAD_FAILURE_MISSING_COLUMN =
    'europa.upload.InitiateDataUpload.MissingColumn';
export const INITIATE_DATA_UPLOAD_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.upload.InitiateDataUpload.NoActiveWarehouseSelected';
export const INITIATE_DATA_UPLOAD_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.upload.InitiateDataUpload.NotAuthenticatedToSnowflake';
export const INITIATE_DATA_UPLOAD_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.upload.InitiateDataUpload.NotExistsOrNotAuthorized';
export const INITIATE_DATA_UPLOAD_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.upload.InitiateDataUpload.NotExistsOrOperationCannotBePerformed';
export const INITIATE_DATA_UPLOAD_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.upload.InitiateDataUpload.ObjectAlreadyExists';
export const INITIATE_DATA_UPLOAD_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.upload.InitiateDataUpload.SchemaNotExistsOrNotAuthorized';
export const INITIATE_DATA_UPLOAD_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.upload.InitiateDataUpload.SnowflakeInternalServerError';
export const INITIATE_DATA_UPLOAD_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.upload.InitiateDataUpload.SnowflakeNotConfigured';
export const INITIATE_DATA_UPLOAD_FAILURE_SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.upload.InitiateDataUpload.SnowflakeObjectNotFoundOrNotAccessible';
export const INITIATE_DATA_UPLOAD_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.upload.InitiateDataUpload.SnowflakeQueryCanceled';
export const INITIATE_DATA_UPLOAD_FAILURE_SNOWFLAKE_TABLE_ALREADY_EXISTS =
    'europa.upload.InitiateDataUpload.SnowflakeTableAlreadyExists';
export const INITIATE_DATA_UPLOAD_FAILURE_TARGET_VIEW_OR_TABLE_NOT_ALLOWED_TO_OVERWRITE =
    'europa.upload.InitiateDataUpload.TargetViewOrTableNotAllowedToOverwrite';
export const INITIATE_DATA_UPLOAD_FAILURE_TIMEOUT = 'europa.upload.InitiateDataUpload.Timeout';
export const INITIATE_DATA_UPLOAD_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.upload.InitiateDataUpload.UncategorizedSqlError';
export const INITIATE_DATA_UPLOAD_FAILURE_UNEXPECTED_FAILURE =
    'europa.upload.InitiateDataUpload.UnexpectedFailure';
export const INITIATE_DATA_UPLOAD_FAILURE_UNKNOWN_FUNCTION =
    'europa.upload.InitiateDataUpload.UnknownFunction';
export const INITIATE_DATA_UPLOAD_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.upload.InitiateDataUpload.UnknownFunctions';
export const INITIATE_DATA_UPLOAD_SUCCESS_UPLOAD_INITIATED =
    'europa.upload.InitiateDataUpload.UploadInitiated';
export const INITIATE_DATA_UPLOAD_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.upload.InitiateDataUpload.UserDiffersFromToken';
export const INITIATE_DATA_UPLOAD_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.upload.InitiateDataUpload.ValueNotRecognized';
export const INITIATE_DATA_UPLOAD_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.upload.InitiateDataUpload.WarehouseSuspended';
